// purpose:
// Holds the current screen's "Next" action so the master layout
// can render a single Next button that triggers the active screen's handler.

import { create } from "zustand";

interface StepActionStore {
  handler: (() => void) | null;
  setHandler: (handler: (() => void) | null) => void;
}

export const useStepActionStore = create<StepActionStore>((set) => ({
  handler: null,
  setHandler: (handler) => set({ handler }),
}));
